import axios from 'axios';

const api = axios.create({
  baseURL: 'https://admin-kits-cali2025.kagencia.com/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

export default api;
